<section class="reward-card" aria-label="Reward card">
  <div class="reward-card__pattern" aria-hidden="true"></div>
  <div class="reward-card__inner">
    <div class="reward-card__top">
      <span class="membership-badge">
        <mat-icon svgIcon="grade"></mat-icon>
        {{ membershipLevel }}
      </span>
      <span class="reward-card__label">Reward card</span>
      <button
        type="button"
        class="icon-btn icon-btn--secondary reward-card__help"
        aria-label="Ayuda sobre puntos"
        (click)="help.emit()"
      >
        <mat-icon svgIcon="question_mark"></mat-icon>
      </button>
    </div>

    <img
      class="reward-card__logo"
      src="./assets/img/logo-capital-divisas.svg"
      alt="Capital Divisas"
    />

    <p class="reward-card__name">{{ holderName | uppercase }}</p>

    <div class="reward-card__bottom">
      <div class="reward-card__points">
        <span class="reward-card__points-icon">
          <img src="./assets/img/circle-icon.svg" alt="" />
        </span>
        <span class="reward-card__points-value">{{ points }}</span>
        <span class="reward-card__points-suffix">pts</span>
      </div>
      <ng-content select="[reward-card-action]"></ng-content>
    </div>
  </div>
</section>
